import CustomerHistory from "../../components/Admin/CustomerProfileDetails/CustomerHistory";
// import CustomerDrafts from "../../components/Admin/CustomerProfileDetails/CustomerDrafts";
import CustomerOngoingOrders from "../../components/Admin/CustomerProfileDetails/CustomerOngoingOrders";
import CustomerRFQs from "../../components/Admin/CustomerProfileDetails/CustomerRFQs";
import CustomerQuotes from "../../components/Admin/CustomerProfileDetails/Quotes";

// import CustomRates from "../../components/Admin/CustomRates";

const CustomerProfileDetails = () => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <CustomerRFQs />
      <CustomerQuotes />
      <div className="col-span-full">
        <CustomerOngoingOrders />
      </div>
      {/* <CustomerDrafts /> */}
      <div className="col-span-full">
        <CustomerHistory />
      </div>
    </div>
  );
};
export default CustomerProfileDetails;
